/* eslint-disable no-unused-vars */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Branch, Listing } from 'src/types';
import { Supplier } from 'src/types/supplier';
import * as thunks from './thunks';
import { CreateListingBundlePayload, ListingBundleDataResponse } from './types';

type State = {
  ListingBundleData: ListingBundleDataResponse;
  createListingBundleLoading: boolean;
};

const initialState: State = {
  ListingBundleData: {
    warranty_duration: 0,
    product_id: 0,
    category_id: 0,
    serial_no: '',
    supplier_id: 0,
    retail_price: 0,
    dealers_price: 0,
    price_type: 0,
    purchase_date: '',
    branch_id: 0,
    status: '',
    dr_no: '',
    created_by: 0,
    updated_at: '',
    created_at: '',
    id: 0,
    items: [
      {
        id: 0,
        main_listing_id: 0,
        listing_id: 0
      }
    ]
  },
  createListingBundleLoading: false
};

const slice = createSlice({
  name: 'listingBundle',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(thunks.createListingBundleThunk.pending, (state) => {
      state.createListingBundleLoading = true;
    });
    builder.addCase(
      thunks.createListingBundleThunk.fulfilled,
      (state, { payload }) => {
        state.createListingBundleLoading = false;
        state.ListingBundleData = payload.originalData.data;
      }
    );
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions,
  ...thunks
};
